import { tableConstantsFactory } from './tableConstantsFactory';
export default tableConstantsFactory('ASSET');